import { render, staticRenderFns } from "./PersonPurchasesDialog.vue?vue&type=template&id=4d4dce8d&scoped=true&lang=pug&"
import script from "./PersonPurchasesDialog.vue?vue&type=script&lang=js&"
export * from "./PersonPurchasesDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d4dce8d",
  null
  
)

export default component.exports